import React from 'react';
import GoogleMap from 'google-map-react';
import LocationOn from '@material-ui/icons/LocationOn';
import { List, ListItem } from '@material-ui/core';
import MAPS_API_KEY from '../../Utils/constants';
import CommonSearch from '../CommonSearch';

// 0-all 1-verified 2-pending 3-rejected

const AnyReactComponent = ({ place }) => {
  switch (place.status) {
    case 0:
      return (
        <div>
          <LocationOn color="primary" fontSize="large" />
        </div>
      )
    case 1:
      return (
        <div>
          <LocationOn color="secondary" fontSize="large" />
        </div>
      )
    case 2:
      return (
        <div>
          <LocationOn color="primary" fontSize="large" />
        </div>
      )
    case 3:
      return (
        <div>
          <LocationOn color="secondary" fontSize="large" />
        </div>
      )
    default:
      return (
        <div>
          <LocationOn color="primary" />
        </div>
      )
  }
};

const Maps = ({
  center, zoom, mapData, data, handleVerification, handleLabelClick, labels, handleSearch,
}) => {
  const onBoundsChange = () => {}

  const onChildClick = (key) => {
    handleVerification(key);
  }

  const onChildMouseEnter = (/* key, childProps */) => {
  }

  const onChildMouseLeave = (/* key, childProps */) => {
  }

  return (
  // Important! Always set the container height explicitly
    <div style={{ height: '500px', width: '100%', position: 'relative' }}>
      <GoogleMap
        bootstrapURLKeys={{ key: MAPS_API_KEY }}
        center={center}
        zoom={zoom}
        onChange={onBoundsChange}
        onChildClick={onChildClick}
        onChildMouseEnter={onChildMouseEnter}
        onChildMouseLeave={onChildMouseLeave}
      >
        {mapData
          .map((place) => {
            const {
              id, lat, lng,
            } = place;
            return (
              <AnyReactComponent
                key={id}
                lat={lat}
                lng={lng}
                place={place}
              />
            );
          })}
      </GoogleMap>
      <div style={{
        position: 'absolute',
        top: 30,
        right: 30,
      }}
      >
        <List component="nav" aria-label="contacts" style={{ backgroundColor: 'white' }}>
          {labels && labels.map((label) => (
            <ListItem key={label.id} button divider onClick={() => handleLabelClick(label.id)}>
              <LocationOn color={label.color} fontSize="small" />
              <span>{label.labelText}</span>
            </ListItem>
          ))}
        </List>
      </div>
      <div style={{
        position: 'absolute',
        top: 30,
        left: 30,
        width: 400,
        backgroundColor: 'rgba(255,255,255, .9)',
      }}
      >
        <CommonSearch data={data} onChange={handleSearch} />
      </div>
    </div>
  )
};

export default Maps;
